<template>
    <footer class="footer">
        <div class="footer__container">
            <div class="footer__row">
                <div class="footer__left">
                    <div class="footer__left-year">
                        © ТЕКТА — {{ year }}
                    </div>
                </div>
                <div class="footer__right">
                    <a href="https://www.kelnik.ru"
                       target="_blank"
                       class="footer__kelnik">
                        <Kelnik />
                    </a>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import Kelnik from '@/components/Icons/Kelnik';

export default {
    name: 'TheFooter',

    components: {
        Kelnik
    },

    data() {
        return {
            year: new Date().getFullYear()
        };
    }
};
</script>

<style lang="scss">
    @import "Footer";
</style>
